import axios from 'axios';
import { ButtonGroup, ComboBox, DataGrid, Dialog, Form, FormField, GridColumn, Label, Layout, LayoutPanel, LinkButton, Panel, TextBox } from 'rc-easyui';
import React, { Component } from 'react';
import { uAPIlocal } from '../../lib/config';
import Loader from 'react-loader-spinner';
import {
    Row,
    Col,
} from "react-bootstrap";
import moment from "moment";
import 'moment/locale/id';
moment.locale('id');

class MasterKonsultasi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            master_log: {
                total: 0,
                pageSize: 20,
                data: [],
                pagePosition: "bottom",
                pageOptions: {
                    layout: ['list', 'sep', 'first', 'prev', 'next', 'last', 'sep', 'refresh', 'sep', 'manual', 'info']
                },
                selection: null,
                loading: true,
            },
            formTambah: {
                field: {
                    ID_DOKTER: "",
                    NAMA_DOKTER: "",
                    ALAMAT: "",
                    NO_TELP: "",
                    SIP: "",
                },
                rules: {
                    ID_DOKTER: ["required"],
                    NAMA_DOKTER: ["required"],
                    ALAMAT: ["required"],
                    NO_TELP: ["required"],
                    SIP: ["required"],
                }
            },
            formEdit: {
                field: {
                    ID_DOKTER: "",
                    NAMA_DOKTER: "",
                    ALAMAT: "",
                    NO_TELP: "",
                    SIP: "",
                },
                rules: {
                    ID_DOKTER: ["required"],
                    NAMA_DOKTER: ["required"],
                    ALAMAT: ["required"],
                    NO_TELP: ["required"],
                    SIP: ["required"],
                }
            },
            loader: false,
        }
        this.errorDialog = React.createRef();
        this.tambahConc = React.createRef();
        this.editConc = React.createRef();

        this.pageChange = this.pageChange.bind(this);
        this.selectionChange = this.selectionChange.bind(this);

        this.formTambah = React.createRef();
        this.handleChangeFormTambah = this.handleChangeFormTambah.bind(this);
        this.handleSubmitFormTambah = this.handleSubmitFormTambah.bind(this);

        this.formEdit = React.createRef();
        this.handleEditClick = this.handleEditClick.bind(this);
        this.handleChangeformEdit = this.handleChangeformEdit.bind(this);
        this.handleSubmitformEdit = this.handleSubmitformEdit.bind(this);

        this.removeDialog = React.createRef();
        this.removedData = this.removedData.bind(this);
        this.handleRemoveClick = this.handleRemoveClick.bind(this);
    }
    async getData() {
        await axios.post(uAPIlocal + '/api/v1/log-master')
            .then(function (response) {
                return response.data.results;
            })
            .then(response => {
                // console.log(response)

                // const data = response.sort(function (a, b) {
                //     return a.NAMA_DOKTER < b.NAMA_DOKTER ? -1 : a.NAMA_DOKTER > b.NAMA_DOKTER ? 1 : 0;
                // });

                this.setState({
                    master_log: {
                        ...this.state.response,
                        data: response,
                        loading: false
                    }
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    pageChange(event) {
        // console.log(event)
        if (event.refresh) {
            // console.log(event)
            this.setState({
                master_log: {
                    ...this.state.master_log,
                    loading: true,
                    selection: null
                },
            })
            this.getData();
        }

    }
    async selectionChange(event) {
        // console.log(event)
        await this.setState({
            master_log: {
                ...this.state.master_log,
                selection: event
            },
        })
    }

    async handleChangeFormTambah(name, value) {
        let field = Object.assign({}, this.state.formTambah.field);
        field[name] = value;
        await this.setState({
            formTambah: {
                ...this.state.formTambah,
                field: field
            }
        }, () => console.log(this.state.formTambah.field))
    }

    async handleSubmitFormTambah() {
        const formData = new FormData();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        const ID_DOKTER = this.state.formTambah.field.ID_DOKTER;
        const NAMA_DOKTER = this.state.formTambah.field.NAMA_DOKTER;
        const ALAMAT = this.state.formTambah.field.ALAMAT;
        const NO_TELP = this.state.formTambah.field.NO_TELP;
        const SIP = this.state.formTambah.field.SIP;
        formData.append('ID_DOKTER', ID_DOKTER);
        formData.append('NAMA_DOKTER', NAMA_DOKTER);
        formData.append('ALAMAT', ALAMAT);
        formData.append('NO_TELP', NO_TELP);
        formData.append('SIP', SIP);

        for (var pair of formData.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        }

        if (ID_DOKTER == '' || NAMA_DOKTER == '' || ALAMAT == '' || NO_TELP == '') {

            this.setState({
                errorMessage: "Form tidak boleh kosong!",
            })
            this.errorDialog.current.open();

        } else {
            await axios.post(uAPIlocal + '/api/v1/master_log', formData, config)
                .then(response => {
                    // console.log(response)
                    if (response.data.status === 406) {
                        this.setState({
                            errorMessage: response.data.message,
                        })
                        this.errorDialog.current.open();
                    } else {
                        this.getData();
                        this.tambahConc.current.close();
                        this.setState({
                            formTambah: {
                                ...this.state.formTambah,
                                field: {
                                    ID_DOKTER: "",
                                    NAMA_DOKTER: "",
                                    ALAMAT: "",
                                    NO_TELP: "",
                                    SIP: "",
                                },
                            }
                        })
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }

    }

    async handleRemoveClick() {
        if (this.state.master_log.selection) {
            this.removeDialog.current.open();
        } else {
            // console.log('tidak ada yang di select');
            this.setState({
                errorMessage: "Tidak Ada Data yang Dipilih",
            })
            this.errorDialog.current.open();
        }
    }

    async removedData() {
        await this.setState({
            loader: true
        })
        const id = this.state.master_log.selection.ID_DOKTER
        await axios.delete(uAPIlocal + `/api/v1/master_log/${id}`)
            .then(function (response) {
                // console.log(response)this.state.pasien.selection.id_regis
                return response.data;
            })
            .then(response => {
                // console.log(response)
                this.getData();
                this.removeDialog.current.close();
                this.setState({
                    loader: false,
                    master_log: {
                        ...this.state.master_log,
                        selection: null
                    },
                })




            })
            .catch(error => {
                console.log(error);
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                    if (error.response.status === 500) {
                        this.setState({
                            loader: false,
                            errorMessage: error.response.data,
                        })
                        this.errorDialog.current.open();
                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    // console.log(error.request);
                    this.setState({
                        loader: false,
                        errorMessage: "Terjadi Kesalahan",
                    })
                    this.errorDialog.current.open();
                } else {
                    // Something happened in setting up the request that triggered an Error
                    // console.log('Error', error.message);
                    this.setState({
                        loader: false,
                        errorMessage: "Terjadi Kesalahan",
                    })
                    this.errorDialog.current.open();
                }

            });
    }

    async handleEditClick() {
        if (this.state.master_log.selection) {
            console.log(this.state.master_log.selection)
            const ID_DOKTER = `${this.state.master_log.selection.DokterID}`
            const NAMA_DOKTER = `${this.state.master_log.selection.NAMA_DOKTER}`
            const ALAMAT = `${this.state.master_log.selection.ALAMAT}`
            const NO_TELP = `${this.state.master_log.selection.NO_TELP}`
            const SIP = `${this.state.master_log.selection.SIP}`
            await this.setState({
                formEdit: {
                    ...this.state.formEdit,
                    field: {
                        ID_DOKTER: ID_DOKTER,
                        NAMA_DOKTER: NAMA_DOKTER,
                        ALAMAT: ALAMAT,
                        NO_TELP: NO_TELP,
                        SIP: SIP,
                    },
                }
            })
            this.editConc.current.open();
        } else {
            // console.log('tidak ada yang di select');
            this.setState({
                errorMessage: "Tidak Ada Data yang Dipilih",
            })
            this.errorDialog.current.open();
        }
    }

    async handleChangeformEdit(name, value) {
        let field = Object.assign({}, this.state.formEdit.field);
        field[name] = value;
        await this.setState({
            formEdit: {
                ...this.state.formEdit,
                field: field
            }
        })
    }
    async handleSubmitformEdit() {
        const formData = new FormData();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        const ID_DOKTER = this.state.formEdit.field.ID_DOKTER;
        const NAMA_DOKTER = this.state.formEdit.field.NAMA_DOKTER;
        const ALAMAT = this.state.formEdit.field.ALAMAT;
        const NO_TELP = this.state.formEdit.field.NO_TELP;
        const SIP = this.state.formEdit.field.SIP;
        formData.append('ID', this.state.master_log.selection.ID_DOKTER);
        formData.append('ID_DOKTER', ID_DOKTER);
        formData.append('NAMA_DOKTER', NAMA_DOKTER);
        formData.append('ALAMAT', ALAMAT);
        formData.append('NO_TELP', NO_TELP);
        formData.append('SIP', SIP);

        for (var pair of formData.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        }

        if (ID_DOKTER == '' || NAMA_DOKTER == '' || ALAMAT == '' || NO_TELP == '') {

            this.setState({
                errorMessage: "Form tidak boleh kosong!",
            })
            this.errorDialog.current.open();

        } else {

            await axios.put(uAPIlocal + '/api/v1/master_log', formData, config)
                .then(response => {
                    if (response.data.status === 406) {
                        this.setState({
                            errorMessage: response.data.message,
                        })
                        this.errorDialog.current.open();
                    } else {
                        this.setState({
                            master_log: {
                                ...this.state.master_log,
                                loading: true
                            }
                        })
                        this.getData();
                        this.editConc.current.close();
                        this.setState({
                            formEdit: {
                                ...this.state.formEdit,
                                field: {
                                    ID_DOKTER: "",
                                    NAMA_DOKTER: "",
                                    ALAMAT: "",
                                    NO_TELP: "",
                                    SIP: "",
                                },
                            }
                        })
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });

        }

    }

    componentDidMount() {
        this.getData();
    }
    componentWillUnmount() {
        window.location.reload();
    }
    render() {
        return (

            <Row>


                <Dialog
                    title="Alert"
                    style={{ width: '300px', height: '84px' }}
                    modal
                    closed={true}
                    ref={this.errorDialog}
                >
                    <p style={{ textAlign: 'center', margin: '10px', fontSize: '16px' }}>{this.state.errorMessage}</p>
                </Dialog>

                <Dialog title="Tambah Dokter"
                    style={{ width: '500px', }}
                    modal
                    closed={true}
                    ref={this.tambahConc}
                >
                    <div className='pd-20'>
                        <Form
                            ref={this.formTambah}
                            style={{ maxWidth: 500 }}
                            model={this.state.formTambah.field}
                            rules={this.state.formTambah.rules}
                            labelWidth={200}
                            // labelAlign="right"
                            labelPosition="top"
                            // floatingLabel
                            // validateRules={this.getCustomRules}
                            onChange={this.handleChangeFormTambah}
                        >
                            <FormField name="ID_DOKTER" label="ID Dokter">
                                <TextBox inputId="t0" name="fid" value={this.state.formTambah.field.ID_DOKTER} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="NAMA_DOKTER" label="Nama Dokter">
                                {/* <ComboBox data={this.state.Test_Code} value={this.state.formTambah.field.Test_ID} ></ComboBox> */}
                                <TextBox inputId="t1" name="ftestid" value={this.state.formTambah.field.NAMA_DOKTER} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="ALAMAT" label="Alamat">
                                <TextBox inputId="t2" name="ftestname" value={this.state.formTambah.field.ALAMAT} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="NO_TELP" label="No. Telp">
                                <TextBox inputId="t3" name="fconcid" value={this.state.formTambah.field.NO_TELP} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="SIP" label="No. SIP">
                                <TextBox inputId="t4" name="fsip" value={this.state.formTambah.field.SIP} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField >
                                <LinkButton onClick={this.handleSubmitFormTambah} >Submit</LinkButton>
                            </FormField>
                        </Form>
                    </div>
                </Dialog>

                <Dialog title="Edit Dokter"
                    style={{ width: '500px', }}
                    modal
                    closed={true}
                    ref={this.editConc}
                >
                    <div className='pd-20'>
                        <Form
                            ref={this.formEdit}
                            style={{ maxWidth: 500 }}
                            model={this.state.formEdit.field}
                            rules={this.state.formEdit.rules}
                            labelWidth={200}
                            // labelAlign="right"
                            labelPosition="top"
                            // floatingLabel
                            // validateRules={this.getCustomRules}
                            onChange={this.handleChangeformEdit}
                        >
                            <FormField name="ID_DOKTER" label="ID Dokter">
                                <TextBox inputId="t0" name="fid" value={this.state.formEdit.field.ID_DOKTER} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="NAMA_DOKTER" label="Nama Dokter">
                                <TextBox inputId="t1" name="ftestid" value={this.state.formEdit.field.NAMA_DOKTER} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="ALAMAT" label="Alamat">
                                <TextBox inputId="t2" name="ftestname" value={this.state.formEdit.field.ALAMAT} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="NO_TELP" label="No. Telp">
                                <TextBox inputId="t3" name="fconcid" value={this.state.formEdit.field.NO_TELP} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="SIP" label="No. SIP">
                                <TextBox inputId="t4" name="fsip" value={this.state.formEdit.field.SIP} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField >
                                <LinkButton onClick={this.handleSubmitformEdit} >Submit</LinkButton>
                            </FormField>
                        </Form>
                    </div>
                </Dialog>
                <Dialog
                    title="Please Confirm"
                    style={{ width: '300px', height: '190px' }}
                    modal
                    closed={true}
                    ref={this.removeDialog}
                    footer={() => {
                        return (
                            this.state.loader ? (
                                <div className="text-center">
                                    <Loader type="TailSpin" color="#00BFFF" height={40} width={100} />
                                </div>
                            ) : (

                                <>
                                    <ButtonGroup style={{ width: '100%', height: '50px' }}>
                                        <LinkButton className="f-full mybtn" plain onClick={this.removedData}>Yakin</LinkButton>
                                        <LinkButton className="f-full mybtn" plain onClick={() => this.removeDialog.current.close()}>Cancel</LinkButton>
                                    </ButtonGroup>
                                </>
                            )
                        )
                    }}

                >
                    <>
                        <p style={{ textAlign: 'center', margin: '10px', fontSize: '16px' }}>Apakah Anda Yakin ?</p>

                    </>
                </Dialog>


                <Col md="12" style={{ backgroundColor: "white", padding: "2px" }}>
                    <Panel
                        title="Master Dokter"
                        collapsible
                    // bodyStyle={{ padding: 20 }}
                    // style={{ height: 500 }}
                    >
                        

                        <div id="DataGrid">
                            <DataGrid
                                {...this.state.master_log}
                                style={{ height: '70vh', }}
                                pagination
                                columnResizing
                                selectionMode="single"
                                onSelectionChange={this.selectionChange}
                                // onPageChange={this.pageChange}
                                filterable
                                virtualScroll
                                columnMoving
                            >
   
                                <GridColumn
                                    sortable
                                    field="name"
                                    title="name"
                                    align="center"
                                    width="100px"
                                ></GridColumn>
                            
                                <GridColumn
                                    field="message"
                                    title="message"
                                    align="center"
                                    width="200px"
                                ></GridColumn>
                                
                                <GridColumn
                                    field="created_at"
                                    title="created_at"
                                    align="center"
                                    width="100px"
                                    render={({ row }) => {
                                        return <b>{moment(moment.utc(row.created_at, 'YYYY-MM-DD hh:mm:ss')).local().format("hh:mm:ss - DD/MM/YYYY")}</b>
                                    }}
                                ></GridColumn>
                   
                            
                            </DataGrid>
                        </div>
                    </Panel>
                </Col>
            </Row>
        )
    }
}
export default MasterKonsultasi